import { localStorageConstants } from "./constants";

type ILocalStorageKeys = keyof typeof localStorageConstants;

export const localStorageGetItem = (
  key: ILocalStorageKeys,
  identifier?: string
): string | boolean | null => {
  const item = localStorage.getItem(
    localStorageConstants[key] + (identifier ? `_${identifier}` : "")
  );
  if (item) {
    switch (key) {
      case "USER_EMAIL":
        return item as string;
      case "INTERNAL_USER_UID":
        return item as string;
      case "INTERNAL_TOKEN":
        return item as string;
      case "USER_UID":
        return item as string;
      case "ADMIN_AVATAR":
        return item as string;
      case "ADMIN_UID":
        return item as string;
      case "EXTRA_CARRIAGE":
        return item === "true";
      case "FIRST_LINE_TITLE":
        return item === "true";
      case "DRAFT_EMAIL_BODY":
        return item as string;
      case "DRAFT_EMAIL_SUBJECT":
        return item as string;
      case "DRAFT_EMAIL_LABELS":
        return item as string;
      case "DRAFT_EMAIL_SPLIT_SUBJECT":
        return item as string;
      case "DRAFT_EMAIL_SPLIT_MODE":
        return item as string;
      case "DRAFT_EMAIL_FONT":
        return item as string;
      case "DRAFT_EMAIL_ZOOM":
        return item as string;
      case "DRAFT_INTEREST_TAGS":
        return item as any;
      case "SCHEDULE_INTERVAL":
        return item as string;
      case "ATOM_CURRENT_RECIPIENTS":
        return item as any;
      case "ATOM_RECIPIENT":
        return item as any;
      case "DRAFT_EMAIL_FONT_SIZE":
        return item as any;
      case "LAST_NOTE_CATEGORY":
        return item as any;
      case "USER_TOKEN":
        return item as string;
      case "SEARCH_INPUT":
        return item as string;
      case "CAMPAIGN_NOTE_ZOOM":
        return item as string;
      case "REFERRAL_CODE":
        return item as string;
      case "MANAGE_SAVED_SEARCHES_GOT_IT":
        return item === "true";
      default:
        return null;
    }
  }
  return null;
};

export const localStorageSetItem = (
  key: ILocalStorageKeys,
  value: string | Record<string, unknown> | Array<Record<string, unknown>>,
  identifier?: string
): void => {
  localStorage.setItem(
    localStorageConstants[key] + (identifier ? `_${identifier}` : ""),
    typeof value === "string" ? value : JSON.stringify(value)
  );
};

export const localStorageRemoveItem = (
  key: ILocalStorageKeys,
  identifier?: string
): void => {
  localStorage.removeItem(
    localStorageConstants[key] + (identifier ? `_${identifier}` : "")
  );
};

export const localStorageClear = (): void => {
  Object.keys(localStorageConstants).forEach((key: string) => {
    localStorage.removeItem(localStorageConstants[key as ILocalStorageKeys]);
  });
};
